import { Box, Typography } from "@mui/material";
import { useContext } from "react";
import { GlobalContext } from "../../../../common/Context";
import {
  background,
  text as textColour,
  white,
} from "../../../../../theme/colours";

const SISideCard = ({ icon, text }) => {
  const { desktopView } = useContext(GlobalContext);

  const containerStyle = {
    display: "flex",
    flex: 1,
    backgroundColor: desktopView ? background.primary : white,
    borderRadius: "0.5rem",
    mb: "1rem",
  };
  const iconStyle = {
    display: "flex",
    alignItems: "center",
    backgroundColor: textColour.primary,
    p: "0.75rem 1rem",
    borderRadius: "0.5rem 0 0 0.5rem",
    "& svg": {
      color: white,
      width: "1.5rem",
      height: "auto",
      "& path": {
        fill: white,
      },
    },
  };
  const textBoxStyle = { display: "flex", alignItems: "center" };
  const textStyle = {
    fontSize: "0.875rem",
    p: "0 1.25rem",
    lineHeight: 1.375,
    fontWeight: 600,
  };

  return (
    <Box sx={containerStyle}>
      <Box sx={iconStyle}>{icon}</Box>
      <Box sx={textBoxStyle}>
        <Typography sx={textStyle}>{text}</Typography>
      </Box>
    </Box>
  );
};

export default SISideCard;
